import firebase from "firebase";

export default {};
